import { RefObject, useEffect } from 'react'

type Params = {
  isIn15MinCutOff: boolean
  scrollContainerRef: RefObject<HTMLDivElement> // 스크롤 컨테이너
  targetRef: RefObject<HTMLDivElement> // 위치 target
  setPosition: (position: { top: number; left: number } | undefined) => void
}

const TOP_SPACE = 12

// 셀 우측의 메뉴 아이콘 바로 아래에 텍스트가 오도록 dropdown.right를 셀 우측 너머로 오프셋
// (드롭다운이 셀 오른쪽으로 일정 픽셀 overflow 되어 옵션 텍스트가 아이콘 아래에 위치)
const RIGHT_OVERFLOW = 130

const IN_15_MIN_OPTIONS_WIDTH = 180
const OPTIONS_WIDTH = 160

export const useOptionsPosition = ({ isIn15MinCutOff, scrollContainerRef, targetRef, setPosition }: Params) => {
  useEffect(() => {
    if (!scrollContainerRef.current || !targetRef.current) return

    const calculateOptionsPosition = (rect: DOMRect) => ({
      top: rect.top + rect.height - TOP_SPACE,
      left: rect.left + rect.width - (isIn15MinCutOff ? IN_15_MIN_OPTIONS_WIDTH : OPTIONS_WIDTH) + RIGHT_OVERFLOW,
    })

    const updatePosition = () => {
      if (!targetRef.current || !scrollContainerRef.current) return

      const containerRect = scrollContainerRef.current.getBoundingClientRect()
      const targetRect = targetRef.current.getBoundingClientRect()

      const topInContainer = targetRect.top - containerRect.top

      const isOverflow = topInContainer - targetRect.height < 0 || topInContainer + targetRect.height > containerRect.height

      if (isOverflow) {
        setPosition(undefined)
        return
      }

      setPosition(calculateOptionsPosition(targetRect))
    }

    const handleScroll = () => requestAnimationFrame(updatePosition)

    scrollContainerRef.current.addEventListener('scroll', handleScroll)

    updatePosition()

    return () => {
      scrollContainerRef.current?.removeEventListener('scroll', handleScroll)
    }
  }, [isIn15MinCutOff])
}
